import { render, staticRenderFns } from "./PointLog.vue?vue&type=template&id=01b73a6f&scoped=true&"
import script from "./PointLog.vue?vue&type=script&lang=js&"
export * from "./PointLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b73a6f",
  null
  
)

export default component.exports